import React from 'react'

import { Select, Typography } from 'antd'
import { SelectProps, DefaultOptionType } from 'antd/lib/select'

import { observer } from 'mobx-react-lite'

import { Box, BoxProps } from 'common/components/boxes'

import { useVendorStores } from 'vendor/hooks/use-stores'
import { ManagedVendorUser } from 'vendor/server/vendor_settings/manage_users'

type SelectUserProps = {
  showAssignToMe?: boolean
  boxProps?: BoxProps
  makeOption: (user: ManagedVendorUser) => DefaultOptionType
} & SelectProps

export const SelectUser = observer<SelectUserProps>(({ showAssignToMe = true, boxProps, makeOption, ...props }) => {
  const { vendorSettingStore, userStore } = useVendorStores()

  const currentUser = userStore.currentUser
  const { value } = props

  const checkCurrentUserIsSelected = () => {
    if (Array.isArray(value)) {
      return value.includes(currentUser?.id)
    }

    return currentUser.id === value
  }

  const options = vendorSettingStore.users.map(makeOption)

  return (
    <Box display="flex" flexDirection="column" width="100%" {...boxProps}>
      <Select
        style={{ width: '100%' }}
        filterOption={(input, option) => {
          const inputValue = input.toLowerCase()
          const label = option?.label as string
          return label?.toLowerCase().includes(inputValue)
        }}
        showSearch
        allowClear
        options={options}
        {...props}
      />

      {showAssignToMe && !checkCurrentUserIsSelected() && (
        <Typography.Link>
          <span
            onClick={(e) => {
              e.stopPropagation()
              if (Array.isArray(value)) {
                props?.onChange?.(
                  [...value, currentUser?.id],
                  [
                    ...options,
                    {
                      value: currentUser?.id,
                      label: currentUser?.name,
                    },
                  ],
                )
              } else {
                props?.onChange?.(currentUser?.id, {
                  value: currentUser?.id,
                  label: currentUser?.name,
                })
              }
            }}
          >
            Assign to me
          </span>
        </Typography.Link>
      )}
    </Box>
  )
})
